import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import type { User } from "../../types";

type AuthState = {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
};

const initialState: AuthState = {
  user: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,
};

const dummyUsers = [
  { username: "test@gmail.com", password: "test1234" },
  { username: "luke.skywalker@resistence.com", password: "password123" },
  { username: "darth.vader@empire.com", password: "iamyourfather" },
  { username: "yoda@jedicouncil.com", password: "challengeyoumusthmm?" },
];

// Simulate async login (would be replaced with real API call)
export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (credentials: { username: string; password: string }) => {
    // Simulate fetching from users.json
    const users = dummyUsers;
    const user = users.find(
      (u) =>
        u.username === credentials.username &&
        u.password === credentials.password
    );
    if (!user) {
      throw new Error("Invalid username or password");
    }
    return { username: user.username };
  }
);

export const logoutUser = createAsyncThunk("auth/logoutUser", async () => {
  return null;
});

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload;
        state.isAuthenticated = true;
        state.error = null;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.isLoading = false;
        state.user = null;
        state.isAuthenticated = false;
        state.error = action.error.message || "Login failed";
      })
      .addCase(logoutUser.fulfilled, (state) => {
        state.user = null;
        state.isAuthenticated = false;
        state.isLoading = false;
        state.error = null;
      });
  },
});

export default authSlice.reducer;
